import axios from 'axios';

const geografiaFunciones = {
    
  obtenerPaises: async () => {
    try {
      const response = await axios.get('/api/paises/list');
      console.log("Lista de países:", response);
      return response.data.paises || [];
    } catch (error) {
      console.error("Error al obtener la lista de países:", error);
      return [];
    }
  },

  obtenerEstadosPorPais: async (paisId) => {
    try {
      const response = await axios.get(`/api/paises/listid/${paisId}`);
      return response.data.estados || [];
    } catch (error) {
      console.error("Error al obtener los estados por país:", error);
      return [];
    }
  },

  obtenerCiudadesPorEstado: async (estadoId) => {
    try {
      const response = await axios.get(`/api/estados/listid/${estadoId}`);
      return response.data.ciudades || [];
    } catch (error) {
      console.error("Error al obtener las ciudades por estado:", error);
      return [];
    }
  },
};

export default geografiaFunciones;